import React, { memo } from 'react';

const BetButton = memo(({ isDisabled, handleClick, text, className, children }) => {
  return (
    <div className='ken-bet-btn-inner '>
      <button
        type='button'
        className={`keno-bet-btn ${className} ${isDisabled ? 'disabled' : ''}`}
        onClick={handleClick}
      >
        <p className='keno-bet-btn-txt-wrapper'>
          {children}
          <span className='bet-btn-txt'>{text}</span>
        </p>
      </button>
    </div>
  );
});
export default BetButton;
